import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import { ConfigApiService } from '../services/config-api.service';
import { Store } from '@ngrx/store';
import { selectAppMeta } from 'src/state/app-meta/app-meta.selectors';

@Injectable()
export class SubscriptionInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //const params = this.configService.getParams();
    const params$ = this.store.select(selectAppMeta);
    let urlParams: string;
    let subId: string;
    let apiKey: string;
    params$.subscribe(params => {
      urlParams = `?user=${params.user}&id=${params.id}&project=${params.project}&key=${params.key}&lng=${params.lng}&country=${params.country}&RID=${params.RID}`;
      subId = params.project;
      apiKey = params.key;
    });

    const subReq = request.clone({
      headers: request.headers.set('subscription-id', subId).set('X-API-Key', apiKey),
      url: request.url + urlParams
    });

    return next.handle(subReq);
  }
}
